export const MANAGE_INVOICE_NOT_SENT_NO_BILLING_EMAIL =
  "Not sent: no billing email";

export type ManageInvoiceDeliverySubline =
  | "Viewed"
  | "Sent"
  | typeof MANAGE_INVOICE_NOT_SENT_NO_BILLING_EMAIL
  | null;

type GetManageInvoiceDeliverySublineInput = {
  latestInvoiceDocumentViewedAtUtcMilli?: number | null;
  latestInvoiceDeliverySentAtUtcMilli?: number | null;
  // Set by the backend when invoice emails to the payer are held because
  // there is no valid billing email.
  paymentRequestHoldReason?: string | null;
};

const isValidUtcMilli = (value?: number | null): value is number =>
  typeof value === "number" && Number.isFinite(value) && value > 0;

export const getManageInvoiceDeliverySubline = ({
  latestInvoiceDocumentViewedAtUtcMilli,
  latestInvoiceDeliverySentAtUtcMilli,
  paymentRequestHoldReason,
}: GetManageInvoiceDeliverySublineInput): ManageInvoiceDeliverySubline => {
  const sentAtIsValid = isValidUtcMilli(
    latestInvoiceDeliverySentAtUtcMilli,
  );
  if (
    sentAtIsValid &&
    isValidUtcMilli(latestInvoiceDocumentViewedAtUtcMilli) &&
    latestInvoiceDocumentViewedAtUtcMilli >=
      latestInvoiceDeliverySentAtUtcMilli
  ) {
    return "Viewed";
  }

  if (sentAtIsValid) {
    return "Sent";
  }

  // Only an invoice that was never sent shows the hold. Real Sent or Viewed
  // evidence wins over a hold that started later.
  if (paymentRequestHoldReason?.trim()) {
    return MANAGE_INVOICE_NOT_SENT_NO_BILLING_EMAIL;
  }

  return null;
};
